@if (toastMessage) {
  <div tabindex="0" class="toast" [ngClass]="toastMessage.type">
    <!-- Top-right controls: progress (for non-warn) + close button -->
    <div class="toast-controls">
      @if (toastMessage.type !== 'warn') {
        <div class="toast-progress" aria-hidden="true">
          <div class="toast-progress-bar" [style.width.%]="progress"></div>
        </div>
      }
      <button class="toast-close" (click)="closeToast()" aria-label="Toast schließen">×</button>
    </div>
    @if (toastMessage.type === 'warn') {
      <img src="/assets/warning.svg" alt="" />
    }
    @if (toastMessage.type === 'success') {
      <img src="/assets/success.svg" alt="" />
    }

    <div class="toastText">
      <h6>{{ toastMessage.title }}</h6>
      <p>{{ toastMessage.message }}</p>

      <!-- Optionaler Link unter dem Text -->
      @if (toastMessage.link) {
        @if (!toastMessage.link.external) {
          <!-- interner Link via Router -->
          <a
            class="toastLink"
            [routerLink]="toastMessage.link.url"
          >{{ toastMessage.link.text }}</a
          >
        } @else {
          <!-- externer Link -->
          <a
            class="toastLink"
            [href]="toastMessage.link.url"
            target="_blank"
            rel="noopener"
          >{{ toastMessage.link.text }}</a
          >
        }
      }
    </div>
  </div>
}
